export default __webpack_public_path__ + "static/pro_impact_1-6ecfe011879d4c57f15ce8710956afa0.webp";